/* ATLAS_PREORDER_PUBLIC_CONFIG=atl08_preorder_v2
   The installer replaces both placeholders with public Supabase browser
   configuration. Never place a service-role key in this asset. */
(function () {
  'use strict';
  if (window.BOOST_PUBLIC_SUPABASE_CONFIG) return;
  window.BOOST_PUBLIC_SUPABASE_CONFIG = Object.freeze({
    url: 'https://zpefopnpabbgvldtvpka.supabase.co',
    anonKey: 'sb_publishable_CWjaAfrZ0ZxVNMBwQBMQVA_rRxwkCiH'
  });
})();
